import _ from 'lodash';

if (typeof window !== 'undefined') {
  window._ = _;
}
